// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__Y10h8","info":"Panel_info__s6RB+","actions":"Panel_actions__XyzXc","button":"Panel_button__CUdW0"};